import React from "react";
import BookmarkPrimaryImg from "../../../assets/bookmark_primary.svg";
import BookmarkWhiteImg from "../../../assets/bookmark_white.svg";

type Props = {
    isFavorited: boolean;
    disabled: boolean;
    handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
};

export const FavoriteButton = React.forwardRef<HTMLButtonElement, Props>(
    (props: Props, ref) => {
        const {
            isFavorited = false,
            disabled = false,
            handleClick,
            className,
        } = props;

        return (
            <button
                ref={ref}
                type="button"
                className={`ml-4 inline-flex items-center justify-center border-0 bg-transparent p-0 leading-none disabled:cursor-not-allowed ${className ?? ""}`}
                onClick={(e) => handleClick(e)}
                disabled={disabled}
            >
                <img
                    src={isFavorited ? BookmarkPrimaryImg : BookmarkWhiteImg}
                    className="w-7"
                    alt={
                        isFavorited
                            ? "お気に入りを解除する"
                            : "お気に入りに登録する"
                    }
                />
            </button>
        );
    }
);

FavoriteButton.displayName = "FavoriteButton";
